import { Button, StatusCard } from "@neonumy/neonumy-ui";
import { Layout } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Page404(): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout>
      <Layout.Content className="info-card">
        <StatusCard
          title={t("Page Not Found")}
          message={t("The page you are looking for does not exist or has been moved")}
        >
          <Button type="primary" onClick={() => navigate("/")}>
            {t("Go to Home")}
          </Button>
        </StatusCard>
      </Layout.Content>
    </Layout>
  );
}
